<mat-tab-group>
    <mat-tab label="Door Types">
        <div class="pt-3">
            <app-door-types></app-door-types>
        </div>
    </mat-tab>
    <mat-tab label="Option Groups">
        <div class="pt-3">
            <app-option-groups></app-option-groups>
        </div>
    </mat-tab>
    <mat-tab label="Form Categories" *appCan="['manage_form_categories', 'add_forms', 'edit_forms']">
        <div class="pt-3">
            <app-form-categories></app-form-categories>
        </div>
    </mat-tab>
</mat-tab-group>
